import { useQuery } from "@tanstack/react-query";
import queryKey from "../../../enumerations/queryKey";
import { apiGetUserInfo } from "../service";

export const useGetUserInfo = (options) => {
  return useQuery(
    [queryKey.USER_INFO],
    () => apiGetUserInfo().then((res) => res.data.data),
    {
      ...options,
    }
  );
};

